/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import headerParameters from './__generated__/CapacityPageHeaderQuery$parameters.ts';
import tableParameters from './__generated__/CapacityPageTableQuery$parameters.ts';
import type { CapacityPageTableQuery } from './__generated__/CapacityPageTableQuery.graphql.ts';
import type { CapacityPageHeaderQuery } from './__generated__/CapacityPageHeaderQuery.graphql.ts';

type CapacityEntryPointComponent = EntryPointComponent<
	{
		capacityHeaderQuery: CapacityPageHeaderQuery;
		capacityTableQuery: CapacityPageTableQuery;
	},
	{},
	{},
	{
		cloudId: string;
		projectKey: string;
		first: number;
	}
>;

export const capacityEntryPoint: EntryPoint<CapacityEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<CapacityEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-capacity", jiraSpaEntry: "async-servicedesk-capacity" */ './CapacityPage.tsx',
		),
		getPreloadProps: ({
			context: { match },
			tenantContext: { cloudId },
		}: EntryPointRouteParams) => {
			const projectKey = match.params.projectKey ?? '';
			return {
				queries: {
					capacityHeaderQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters: headerParameters,
						variables: {
							input: {
								cloudId,
								projectKey,
							},
						},
					},
					capacityTableQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters: tableParameters,
						variables: {
							input: {
								cloudId,
								projectKey,
							},
							first: 20,
							after: null,
							cloudId,
							projectKey,
						},
					},
				},
				extraProps: {
					cloudId,
					projectKey,
					first: 20,
				},
			};
		},
	});
